
(function () {
  'use strict';
  if (window.OOCVR) return;

  var script = document.currentScript || document.querySelector('script[src*="oo-cvr.js"]');
  var scriptSrc = (script && script.src) || '';
  var onShopifyCdn = /\/cdn\/shop\/|cdn\.shopify\.com/.test(scriptSrc);
  var assetDir = scriptSrc.replace(/oo-cvr\.js.*$/, '');

  var DEFAULTS = {
    cell: null,
    cartCell: null,
    fabricSock: { price: 0, variants: {} },
    mock: null,
    showTK: null,
    landingUrl: '/pages/owlet-one-tier-e',
    imgBase: onShopifyCdn ? assetDir : assetDir + 'img/',
    owletOne: {
      handle: 'owlet-one',
      variantId: 67828681113799,
      sellingPlanId: 6363021511,
      upfront: 299,
      monthly: 19,
      commitmentMonths: 6,
      color: 'Mint',
      colorProperty: 'Sock color'
    },

    includedVariantIds: [46751269814471],
    products: {
      sock: {
        handle: 'owlet-dream-sock', name: 'Dream Sock®', short: 'Dream Sock', price: 299,
        colors: [
          { name: 'Mint', hex: '#badfcf', variantId: 43878918389959, img: 'sock-mint.jpg' },
          { name: 'Bedtime Blue', hex: '#71769d', variantId: 44457099788487, img: 'sock-bedtime-blue.jpg' },
          { name: 'Dusty Rose', hex: '#bfaea5', variantId: 44533297578183, img: 'sock-dusty-rose.jpg' },
          { name: 'Sweet Clementine', hex: '#ffcf94', variantId: 46976102990023, img: 'sock-sweet-clementine.jpg' }
        ]
      },
      duo: {
        handle: 'dream-duo-3', name: 'Dream Duo™', short: 'Dream Duo', price: 379,
        colors: [
          { name: 'Mint', hex: '#badfcf', variantId: 45407711199431, img: 'duo-mint.jpg' },
          { name: 'Dusty Rose', hex: '#bfaea5', variantId: 45407711232199, img: 'duo-dusty-rose.jpg' },
          { name: 'Bedtime Blue', hex: '#71769d', variantId: 45407711264967, img: 'duo-bedtime-blue.jpg' },
          { name: 'Blue Mist', hex: '#8ca0be', variantId: 46976105545927, img: 'duo-blue-mist.jpg' },
          { name: 'Sweet Clementine', hex: '#ffcf94', variantId: 46976107741383, img: 'duo-sweet-clementine.jpg' }
        ]
      }
    },

    swatchHex: { 'Mint': '#badfcf', 'Bedtime Blue': '#71769d', 'Dusty Rose': '#bfaea5', 'Blue Mist': '#8ca0be', 'Sweet Clementine': '#ffcf94' },
    sockCuts: { 'Mint': 'sock-cut-mint.png', 'Bedtime Blue': 'sock-cut-bedtime-blue.png', 'Dusty Rose': 'sock-cut-dusty-rose.png', 'Sweet Clementine': 'sock-cut-sweet-clementine.png' },
    images: {
      ooLogo: 'owlet-one-logo-short.svg',
      mrSun: 'mr-sun.svg', mrChevron: 'mr-chevron.svg', mrArc: 'mr-arc.svg',
      sockCut: 'hero-sock.png',
      baseCut: 'hero-base.png',
      sightCut: 'hero-sight.png',
      thermCut: 'thermometer-cut.png',
      standCut: 'floor-stand-thumb.jpg',
      appCut: 'hero-app-clean.png',
      sightPhoto: 'sight-2.jpg',
      cardSock: 'card-sock.jpg', cardSight: 'card-sight.jpg', cardTherm: 'card-thermometer.jpg'
    },
    selectors: {
      productRoot: '.main-product__product',
      productInfo: '.xo-product-info-content',
      price: '.xo-product-info-content__price',
      variantBlock: '.xo-product-info-content__variant',
      selectedColor: 'xo-product-variant-selected[xo-name="Color"]',
      buyForm: '.xo-product-info-content__buy-form',
      addToCart: '.xo-product-info-content__add-cart button',
      buyNow: '.xo-product-info-content__buy-now',
      addOns: '.xo-product-info-content__buy-form [class*="upsell"], .xo-product-info-content__buy-form [class*="essential"]',
      mediaStage: '.main-product__image xo-carousel-inner',

      ooContentAfter: '.shopify-section[id*="__media_video"], .shopify-section[id*="__image_banner_style_2_xKEhgD"], [data-oo-content-after]',

      productFaq: '.shopify-section[id*="__collapse_content"], [data-oo-product-faq]',
      productFaqItem: '.xo-collapse, [data-oo-faq-item]',
      productFaqQ: '.xo-collapse__trigger-title, [data-oo-faq-q]',
      productFaqA: '.xo-collapse__content, [data-oo-faq-a]',
      affirmText: 'Buy now and pay as low as',
      cartDrawer: 'xo-cart-mini',
      cartLine: '.xo-cart-mini-item',
      cartLineVariantAttr: 'xo-product-id',
      cartLineContent: '.xo-cart-mini-item__content',
      cartFooter: '.essential-upsell-side-cart-bottom, .xo-cart-note, .xo-cart-mini-footer',
      cartTrigger: 'xo-modal-trigger[xo-name="cart"]',
      cartSectionId: 'xo-cart-mini'
    }
  };

  var COPY = {
    promise: { sock: 'Same {up} today. <em>More in the box.</em>', duo: 'Save $80 today. <em>Get more in the box.</em>' },
    choose: 'Select One',
    onceTitle: '{name}',
    oncePrice: '{once}',
    oncePriceNote: 'one time',
    ooTitle: 'Owlet One',
    ooPrice: '{up} today',
    ooPriceMo: '+ {mo}/mo',
    ooSub: {
      sock: 'Adds Dream Sight™ Camera, Smart Thermometer, Owlet360™ and member perks.',
      duo: 'Adds Smart Thermometer, Owlet360™ and member perks to everything in Dream Duo™.'
    },
    covers: 'Your {mo}/mo covers Owlet360™ insights and member perks.',
    priceToday: 'today',
    priceNote: { sock: 'Same upfront price as Dream Sock® alone', duo: '$80 less than Dream Duo™ today' },
    coversShort: '{mo}/mo covers Owlet360™ insights and member perks.',
    terms: '{n}-month minimum.',
    details: 'How Owlet One works',
    atcOO: 'Add to Cart',
    segOnce: '{short} only',
    segOO: 'Owlet One',
    inTheBox: 'In the box',
    boxYours: 'Yours either way',
    boxAdded: 'Added',
    addsWithOO: 'With Owlet One',
    included: 'Included',
    items: {
      sock: { name: 'Dream Sock®', note: { sock: 'The one you picked', duo: 'Also in Dream Duo™' } },
      sight: { name: 'Dream Sight™ Camera', note: { sock: '2K HD video, night vision, two-way talk', duo: 'Also in Dream Duo™' } },
      therm: { name: 'Smart Thermometer', note: { sock: 'Fast, accurate, and connected.', duo: 'Fast, accurate, and connected.' } },
      stand: { name: 'Dream Sight™ Floor Stand', note: { sock: 'Holds your camera at the right angle over the crib', duo: 'Holds your camera at the right angle over the crib' } },
      o360: { name: 'Owlet360™', note: { sock: 'Morning Report and weekly health & sleep trends', duo: 'Morning Report and weekly health & sleep trends' } }
    },
    reasons: {
      sight: { title: 'Dream Sight™ Camera', text: '2K HD video, night vision and two-way talk.' },
      therm: { title: 'Smart Thermometer', text: 'Readings in just one second, with optional syncing to the Owlet Dream app.' },
      sock: { title: 'Dream Sock®', text: 'Live pulse rate and oxygen level, with alerts if readings leave their zones.' },
      stand: { title: 'Dream Sight™ Floor Stand', text: 'Holds your camera at the right angle over the crib.' },
      o360: { title: 'Owlet360™', text: 'Morning Report and weekly health & sleep trends.' },
      price: { sock: { title: 'Same {up} today', text: 'The same upfront price as Dream Sock® alone.' }, sight: { title: 'Just {diff} more today', text: '{up} instead of {once} for the Dream Sight™ Camera alone.' }, duo: { title: 'Save $80 today', text: '{up} instead of {once} for Dream Duo™.' } }
    },

    crossTitle: { sock: 'Same {up} today. <em>More in the box.</em>', duo: 'Save $80 today. <em>Get more in the box.</em>' },
    crossText: { sock: 'Owlet One adds Dream Sight™ Camera, Smart Thermometer, Owlet360™ and member perks for {mo}/mo.', duo: 'Owlet One is everything in Dream Duo™ plus Smart Thermometer, Owlet360™ and member perks, for {up} and {mo}/mo.' },
    crossRow: { sock: 'Or get Owlet One: same {up}, plus Dream Sight™ Camera, Smart Thermometer and member perks.', duo: 'Or get Owlet One: $80 less, plus Smart Thermometer, Owlet360™ and member perks.' },
    crossLink: 'Compare Owlet One',

    cartHead: { sock: 'Get more for the same price today', duo: 'Save $80 today and get more', sight: 'Upgrade to Owlet One for just {diff} more' },
    swap: 'Switch to Owlet One',
    keep: '{short} only',
    keptRow: 'Owlet One: same {up}, plus Dream Sight™ Camera, Smart Thermometer and member perks.',
    colorChange: 'Heads up: Owlet One comes in Mint only, so your {color} {short} will change to Mint.',
    addonLabel: 'Also add a {color} fabric sock for {price}',
    changedToMint: 'Your {color} {short} was changed to Mint, the only color available with Owlet One.',
    addonAdd: 'Add a {color} fabric sock for {price}',
    keptRowSight: 'Owlet One: just {diff} more, plus Dream Sock®, Smart Thermometer, Owlet360™ and member perks.',
    keptRowDuo: 'Owlet One: $80 less, plus Smart Thermometer, Owlet360™ and member perks.',
    show: 'Show me',
    nudge: { sock: 'Same {up}, plus Dream Sight™ Camera, Smart Thermometer and member perks.', duo: 'Save $80, plus Smart Thermometer, Owlet360™ and member perks.' },
    nudgeCta: 'See how',
    lineOnce: 'Pay once',
    lineOO: 'Owlet One',
    lineOOCaption: 'Adds Dream Sight™ Camera, Smart Thermometer, Owlet360™ and member perks',
    lineOOCaptionDuo: 'Adds Smart Thermometer, Owlet360™ and member perks',
    includesLine: 'Includes Dream Sock® and Dream Sight™ Camera',
    swapped: 'You’re on Owlet One',
    swappedText: 'Dream Sock® and Dream Sight™ Camera, plus Smart Thermometer, Owlet360™ and member perks, are included.',
    swappedTextSight: 'Dream Sock®, Smart Thermometer, Owlet360™ and member perks are included with your Dream Sight™ Camera.',
    swappedTextDuo: 'Your Dream Duo™ gear plus Smart Thermometer, Owlet360™ and member perks are included.',
    undo: 'Switch back to {short} (pay once)',
    removedIncluded: 'We removed the Owlet360™ Annual Plan from your cart because it’s included.',

    sheetCompareOnce: '{short} alone',
    sheetRows: [
      { label: 'Dream Sock®', once: 'sock', oo: true },
      { label: 'Dream Sight™ Camera', once: 'cam', oo: true },
      { label: 'Smart Thermometer', once: false, oo: true, ship: true },
      { label: 'Dream Sight™ Floor Stand', once: false, oo: true },
      { label: 'Owlet360™ insights', once: false, oo: true },
      { label: 'Warranty', onceText: '12 months', ooText: '18 months' },
      { label: 'Member perks', once: false, oo: true }
    ],
    sheetToday: 'Today',
    sheetThen: 'Monthly',
    sheetThenOnce: '-',
    sheetThenOO: '{mo}/mo',
    sheetCoversTitle: 'What your {mo}/mo pays for',
    sheetCovers: 'Owlet360™ (your Morning Report and weekly health & sleep trends), plus member perks. It’s what keeps Dream Sight™ Camera, Smart Thermometer and insights in your Owlet One.',
    faq: [
      { q: 'I’d rather not have a subscription.', a: 'That’s okay. {name} is {once} once, and it’s yours. Nothing changes if you keep it.' },
      { q: 'Can I cancel?', a: 'You can cancel after your first {n} monthly payments, but an active Owlet One membership is required to access in-app features.' },
      { q: 'When am I charged?', a: '{up} at checkout, then {mo} a month, starting about 30 days later.' },
      { q: 'Is it HSA/FSA eligible?', a: 'The upfront cost is HSA/FSA eligible. The monthly payments are not.' }
    ],
    fine: 'Owlet One is a membership. {up} is charged at checkout; {mo}/month begins about 30 days later. Requires a {n}-month minimum commitment. You can cancel after your first {n} monthly payments are complete. Available exclusively on owletcare.com. Limited availability. See Owlet One Terms.',
    chooseOO: 'Choose Owlet One',

    moreH: { sock: 'What you get for <em>the same {up}.</em>', duo: 'What you get for <em>$80 less today.</em>' },
    moreSock: { sock: 'The one you came for. Live pulse rate and oxygen level, with alerts if readings leave their&nbsp;zones.', duo: 'The Sock from your Dream Duo™. Live pulse rate and oxygen level, with alerts if readings leave their&nbsp;zones.' },
    moreSight: { sock: '2K HD video with night vision, two-way talk, room temp &amp; humidity.', duo: 'Still in the box: 2K HD video with night vision, two-way talk, room temp &amp; humidity.' },
    moreTherm: 'Fast, accurate, and connected. Readings in just one second, with optional syncing to the Owlet Dream app.',
    thermShip: 'Starts shipping week of 11/8',
    pays: 'Your {mo}/month covers Owlet360™ insights and keeps your Dream Sight™ Camera, Smart Thermometer and member perks coming.',
    paysList: ['Owlet360™ Morning Report', 'Weekly health &amp; sleep trends', 'Member perks'],
    chartH: 'What you get, <em>side by side.</em>',
    faqH: 'Frequently asked questions',
    faqWhy: { q: 'Why {mo} a month?', a: 'It pays for what’s in the box and what keeps coming: Owlet360™ insights, Dream Sight™ Camera and Smart Thermometer, and member perks.' },
    close: 'Close'
  };

  var userCfg = window.OO_CVR || {};
  var cfg = merge(merge({}, DEFAULTS), userCfg);
  cfg.copy = merge(merge({}, COPY), userCfg.copy || {});
  var C = cfg.copy;
  if (typeof cfg.landingUrl !== 'string' || !/^\/(?![\/\\])/.test(cfg.landingUrl)) cfg.landingUrl = DEFAULTS.landingUrl;

  var host = location.hostname;
  var isStorefront = !!(window.Shopify && window.Shopify.shop) || /owletcare\.com$|myshopify\.com$/.test(host);
  if (cfg.mock === null) cfg.mock = !isStorefront;
  if (cfg.showTK === null) cfg.showTK = false;

  function merge(a, b) {
    Object.keys(b || {}).forEach(function (k) {
      if (k === '__proto__' || k === 'constructor' || k === 'prototype') return;
      var v = b[k];
      if (v && typeof v === 'object' && !Array.isArray(v) && a[k] && typeof a[k] === 'object' && !Array.isArray(a[k])) a[k] = merge(merge({}, a[k]), v);
      else a[k] = v;
    });
    return a;
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(n) { return '$' + (Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2)); }
  function img(key) { var f = cfg.images[key] || key; return /^(https?:)?\/\//.test(f) || f.charAt(0) === '/' ? f : cfg.imgBase + f; }

  var NS = cfg.storageNs || (cfg.mock ? new URLSearchParams(location.search).get('oo_ns') : '') || '';
  function store(k, v) { k = NS + k; try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function t(str, product) {
    if (str && typeof str === 'object') str = str[product] || str.sock;
    var p = cfg.products[product] || cfg.products.sock;
    var oo = cfg.owletOne;
    var out = String(str == null ? '' : str)
      .replace(/\{name\}/g, p.name).replace(/\{short\}/g, p.short)
      .replace(/\{once\}/g, money(p.price)).replace(/\{up\}/g, money(oo.upfront))
      .replace(/\{mo\}/g, money(oo.monthly)).replace(/\{n\}/g, oo.commitmentMonths)
      .replace(/\{save\}/g, money(Math.floor(p.price - oo.upfront)))
      .replace(/\{diff\}/g, money(Math.floor(oo.upfront - p.price)));
    return out.replace(/\s*\[TK:?\s*([^\]]*)\]/g, function (m, note) {
      return cfg.showTK ? ' <span class="oo-tk" title="To confirm: ' + esc(note || 'TBD') + '">TK</span>' : '';
    });
  }

  var params = new URLSearchParams(location.search);
  var urlCell = cfg.cell && !cfg.mock ? null : params.get('oo_cell');
  if (urlCell) store('oo_cell', urlCell);
  var cell = urlCell || cfg.cell || store('oo_cell') || document.documentElement.getAttribute('data-oo-cell') || 'control';
  if (cell === 'C3') cell = 'C1';
  if (!/^(control|A[1-4]|B-(card|row)|C[1-3])$/.test(cell)) cell = 'control';
  var family = cell.charAt(0);
  var cartCell = /^C[12]$/.test(cfg.cartCell) ? cfg.cartCell : (family === 'C' ? cell : null);

  var ctx = { from: params.get('from') === 'duo' ? 'duo' : (params.get('from') === 'sock' ? 'sock' : null), color: params.get('color') };

  function attrProduct(el) {
    var v = el && el.getAttribute('data-oo-product');
    return v === 'sock' || v === 'duo' ? v : null;
  }
  function attrSource(el) {
    var v = el.getAttribute('data-oo-source');
    return v && /^[\w-]{1,32}$/.test(v) ? v : null;
  }

  function pageProduct() {
    if (cfg.pageProduct) return cfg.pageProduct;
    var path = location.pathname;
    if (path.indexOf('/products/' + cfg.products.duo.handle) > -1) return 'duo';
    if (path.indexOf('/products/' + cfg.products.sock.handle) > -1) return 'sock';
    return attrProduct($('[data-oo-product]'));
  }

  function selectedColor(product) {
    var el = $(cfg.selectors.selectedColor);
    var name = (el && el.textContent.trim()) || ctx.color || (cfg.products[product] || cfg.products.sock).colors[0].name;
    return colorObj(product, name).name;
  }
  function colorObj(product, name) {
    var list = (cfg.products[product] || cfg.products.sock).colors;
    for (var i = 0; i < list.length; i++) if (list[i].name.toLowerCase() === String(name).toLowerCase()) return list[i];
    return list[0];
  }
  function productByVariant(id) {
    id = Number(id);
    var found = null;
    ['sock', 'duo', 'sight'].forEach(function (k) { cfg.products[k].colors.forEach(function (c) { if (c.variantId === id) found = { product: k, color: c }; }); });
    return found;
  }

  function track(action, data) {
    var detail = merge({ event: 'oo_cvr', oo_action: action, oo_cell: cell, oo_page: pageProduct() || (ctx.from ? 'landing' : 'other') }, data || {});
    (window.dataLayer = window.dataLayer || []).push(detail);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('oo_cvr_' + action, detail); } catch (e) {}
    window.dispatchEvent(new CustomEvent('oo:track', { detail: detail }));
  }

  function commit(apply, animate) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (animate && !reduce && document.startViewTransition) {
      document.documentElement.classList.add('oo-vt');
      var vt = document.startViewTransition(apply);
      vt.finished.then(function () { document.documentElement.classList.remove('oo-vt'); }, function () { document.documentElement.classList.remove('oo-vt'); });
      return vt.updateCallbackDone;
    }
    apply();
    return Promise.resolve();
  }

  function shopifyError(j, fallback) {
    var e = new Error((j && (j.description || j.message)) || fallback);
    e.userFacing = !!(j && (j.description || j.message));
    return e;
  }

  var ShopifyCart = {
    get: function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); },
    add: function (items) {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw shopifyError(j, 'Add failed'); return j; }); });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw shopifyError(j, 'Update failed'); return j; }); });
    },
    update: function (updates) {
      return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw shopifyError(j, 'Update failed'); return j; }); });
    },

    refresh: function (animate) {
      var id = cfg.selectors.cartSectionId;
      return Promise.all([fetch('/?sections=' + id).then(function (r) { return r.json(); }), ShopifyCart.get()]).then(function (res) {
        var sections = res[0], cart = res[1];
        return commit(function () {
        if (window.xoStore && xoStore.set) {
          xoStore.set('xo-cart', function (s) { s = s || {}; return merge(merge({}, s), { size: cart.item_count, sections: merge(merge({}, s.sections || {}), sections) }); });
        } else {
          var el = document.getElementById(id); if (el && sections[id]) el.innerHTML = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('#' + id).innerHTML;
        }
        window.dispatchEvent(new CustomEvent('oo:cart', { detail: cart }));
        }, animate).then(function () { return cart; });
      });
    },
    open: function () {
      var drawer = $(cfg.selectors.cartDrawer);
      var modal = drawer && drawer.closest('xo-modal');
      function show() {
        if (modal && (modal.hasAttribute('xo-active') || modal.hasAttribute('xo-open'))) return;
        var trig = $(cfg.selectors.cartTrigger); if (trig) trig.click();
      }
      show();
      setTimeout(show, 600);
      setTimeout(show, 1500);
    }
  };

  var MockCart = {
    _c: function () { return store('oo_mock_cart') || { items: [] }; },

    _s: function (c) { store('oo_mock_cart', c); return MockCart._view(c); },
    _view: function (c) {
      var total = 0, count = 0;
      c.items.forEach(function (i) { total += i.price * i.quantity; count += i.quantity; });
      return { items: c.items, item_count: count, total_price: Math.round(total) };
    },
    get: function () { return Promise.resolve(MockCart._view(MockCart._c())); },
    add: function (items) {
      var c = MockCart._c();
      items.forEach(function (it) {
        var line = describeVariant(it);
        var same = c.items.filter(function (i) { return i.variant_id === line.variant_id && JSON.stringify(i.properties) === JSON.stringify(line.properties); })[0];
        if (same) same.quantity += it.quantity || 1; else c.items.push(line);
      });
      return new Promise(function (res) { setTimeout(function () { res(MockCart._s(c)); }, 280); });
    },
    change: function (key, qty) {
      var c = MockCart._c();
      c.items = c.items.map(function (i) { if (i.key === key) i.quantity = qty; return i; }).filter(function (i) { return i.quantity > 0; });
      return new Promise(function (res) { setTimeout(function () { res(MockCart._s(c)); }, 200); });
    },
    update: function (updates) {
      var c = MockCart._c();
      Object.keys(updates).forEach(function (k) {
        var byKey = c.items.filter(function (i) { return i.key === k; })[0];
        var byVariant = c.items.filter(function (i) { return String(i.variant_id) === k; })[0];
        var line = byKey || byVariant;
        if (line) line.quantity = updates[k]; else if (updates[k] > 0 && k.indexOf(':') < 0) c.items.push(describeVariant({ id: Number(k), quantity: updates[k] }));
      });
      c.items = c.items.filter(function (i) { return i.quantity > 0; });
      return new Promise(function (res) { setTimeout(function () { res(MockCart._s(c)); }, 200); });
    },
    refresh: function (animate) { return MockCart.get().then(function (cart) { return commit(function () { window.dispatchEvent(new CustomEvent('oo:cart', { detail: cart })); }, animate).then(function () { return cart; }); }); },
    open: function () { window.dispatchEvent(new CustomEvent('oo:open-cart')); }
  };

  function describeVariant(it) {
    var id = Number(it.id), props = it.properties || {};
    var key = id + ':' + Math.random().toString(36).slice(2, 8);
    if (id === cfg.owletOne.variantId) {
      return { key: key, variant_id: id, product: 'oo', product_title: 'Owlet One', price: cfg.owletOne.upfront * 100, quantity: it.quantity || 1, properties: props, selling_plan: it.selling_plan, image: img('ooLogo'), options: props[cfg.owletOne.colorProperty] ? [cfg.owletOne.colorProperty + ': ' + props[cfg.owletOne.colorProperty]] : [] };
    }
    if (cfg.includedVariantIds.indexOf(id) > -1) {
      return { key: key, variant_id: id, product: 'o360', product_title: 'Owlet360™ Annual Plan', price: 9900, quantity: it.quantity || 1, properties: props, image: img('o360-1.jpg'), options: [] };
    }
    var f = productByVariant(id) || { product: 'sock', color: cfg.products.sock.colors[0] };
    var p = cfg.products[f.product];
    return { key: key, variant_id: id, product: f.product, product_title: p.name + (f.product === 'duo' ? ' (Gen 3)' : ''), price: Math.round(p.price * 100), quantity: it.quantity || 1, properties: props, image: img(f.color.img), options: ['Color: ' + f.color.name] };
  }

  var Cart = cfg.mock ? MockCart : ShopifyCart;

  var busy = false;
  function withBusy(btn, fn) {
    if (busy) return Promise.resolve();
    busy = true;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return fn().catch(function (e) {
      toast(e && e.userFacing ? e.message : 'Something went wrong. Please try again.');
      if (window.console) console.warn('[OOCVR]', e);
      if (cartCell) return Cart.refresh(true).catch(function () {});
    })
      .then(function () { busy = false; if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  function ooItem(product, color, extraProps) {
    var props = {}; props[cfg.owletOne.colorProperty] = cfg.owletOne.color;
    props._oo_cell = cell; props._oo_from = product; props._oo_page = location.pathname;
    return { id: cfg.owletOne.variantId, quantity: 1, selling_plan: cfg.owletOne.sellingPlanId, properties: merge(props, extraProps || {}) };
  }

  function addOwletOne(opts) {
    opts = opts || {};
    var product = opts.product || pageProduct() || ctx.from || 'sock';
    var color = opts.color || selectedColor(product);
    track('add_owlet_one', { product: product, color: color, source: opts.source || cell });
    store('oo_reopen', Date.now());
    return Cart.add([ooItem(product, color)]).then(function () { return Cart.refresh(); }).then(function () { Cart.open(); setTimeout(function () { store('oo_reopen', null); }, 5000); });
  }

  function addOnce(opts) {
    opts = opts || {};
    var product = opts.product || ctx.from || pageProduct() || 'sock';
    var c = colorObj(product, opts.color || selectedColor(product));
    track('add_once', { product: product, color: c.name, source: opts.source || cell });
    return Cart.add([{ id: c.variantId, quantity: 1, properties: { _oo_page: location.pathname } }]).then(function () { return Cart.refresh(); }).then(function () { Cart.open(); });
  }

  function colorSwitch(line) {
    var f = productByVariant(line && line.variant_id), n = f && f.product !== 'sight' && f.color.name;
    return n && n !== cfg.owletOne.color ? n : null;
  }
  function fabricItem(color) {
    var id = cfg.fabricSock.variants[color];
    return id ? { id: id, quantity: 1 } : null;
  }
  function fill(str, color, product) { return t(str, product).replace(/\{color\}/g, esc(color)).replace(/\{price\}/g, money(cfg.fabricSock.price)); }

  function swapLine(line, opts) {
    var f = productByVariant(line.variant_id); if (!f) return Promise.resolve();
    var removed = [];
    track('swap_to_owlet_one', { product: f.product, color: f.color.name });
    return Cart.get()
      .then(function (cart) {
        var chain = Promise.resolve();
        cart.items.forEach(function (i) {
          if (cfg.includedVariantIds.indexOf(Number(i.variant_id)) > -1) { removed.push({ id: i.variant_id, quantity: i.quantity }); chain = chain.then(function () { return Cart.change(i.key, 0); }); }
        });
        return chain;
      })
      .then(function () { return Cart.change(line.key, line.quantity - 1); })
      .then(function () {
        var items = [ooItem(f.product, f.color.name, { _oo_cell: cartCell, _oo_swapped_from: String(line.variant_id) })];
        var addon = opts && opts.addon && colorSwitch(line) && fabricItem(f.color.name);
        if (addon) items.push(addon);
        store('oo_swap', { variantId: line.variant_id, product: f.product, color: f.color.name, removed: removed, addon: !!addon });
        store('oo_kept', null);
        store('oo_reopen', Date.now());
        return Cart.add(items);
      })
      .catch(function (e) {
        store('oo_swap', null); store('oo_reopen', null);
        var back = [{ id: line.variant_id, quantity: 1 }].concat(removed.map(function (r) { return { id: r.id, quantity: r.quantity }; }));
        return Cart.add(back).then(function () { throw e; });
      })
      .then(function () { return Cart.refresh(true); })
      .then(function () { if (removed.length) toast(C.removedIncluded, true); });
  }

  function undoSwap() {
    var s = store('oo_swap'); if (!s) return Promise.resolve();
    track('undo_swap', { product: s.product });
    store('oo_reopen', Date.now());
    return Cart.get().then(function (cart) {
      var updates = {};
      var lineOf = function (id) { return cart.items.filter(function (i) { return Number(i.variant_id) === Number(id); })[0]; };
      var oo = lineOf(cfg.owletOne.variantId);
      if (oo) updates[oo.key] = oo.quantity - 1;
      var fabLine = s.addon && lineOf(cfg.fabricSock.variants[s.color]);
      if (fabLine) updates[fabLine.key] = fabLine.quantity - 1;
      [{ id: s.variantId, quantity: 1 }].concat(s.removed || []).forEach(function (r) {
        var k = String(r.id), had = lineOf(r.id);
        updates[k] = (updates[k] !== undefined ? updates[k] : (had ? had.quantity : 0)) + (r.quantity || 1);
      });
      return Cart.update(updates);
    }).then(function () { store('oo_swap', null); store('oo_kept', true); store('oo_nudge_open', null); return Cart.refresh(true); });
  }

  function thumbs(keys, cls) {
    return '<span class="oo-thumbs ' + (cls || '') + '" aria-hidden="true">' + keys.map(function (k) {
      var src = k === 'sock' ? sockSrc() : img({ sight: 'sightCut', therm: 'thermCut', stand: 'standCut', o360: 'appCut', base: 'baseCut' }[k]);
      return '<span class="oo-thumbs__i oo-thumbs__i--' + k + '"><img src="' + src + '" alt="" loading="lazy"' + (k === 'sock' ? ' data-oo-sock' : '') + '></span>';
    }).join('') + '</span>';
  }
  function sockSrc(product) {
    var name = selectedColor(product || pageProduct() || ctx.from || 'sock');
    return img(cfg.sockCuts[name] || cfg.sockCuts.Mint);
  }
  function syncSockColor() { var src = sockSrc(); $$('img[data-oo-sock]').forEach(function (i) { if (i.getAttribute('src') !== src) i.setAttribute('src', src); }); }
  function addKeys(product) { return product === 'duo' ? ['therm', 'o360'] : ['sight', 'therm', 'o360']; }
  function check() { return '<svg class="oo-ico" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M5 10.5l3.2 3.2L15 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
  function dash() { return '<svg class="oo-ico" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M6 10h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'; }
  function chevron() { return '<svg class="oo-ico" viewBox="0 0 20 20" width="14" height="14" aria-hidden="true"><path d="M8 5l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
  function logo() { return '<img class="oo-logo" src="' + img('ooLogo') + '" alt="Owlet One" width="104" height="28">'; }

  function toast(msg, html) {
    var el = $('.oo-toast');
    if (!el) { el = document.createElement('div'); el.className = 'oo oo-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); document.body.appendChild(el); }
    if (html) el.innerHTML = msg; else el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-on'); }, 4200);
  }

  function openSheet(product, mode) {
    product = product || pageProduct() || ctx.from || 'sock';
    track('details_open', { product: product, mode: mode });
    var d = $('#oo-sheet');
    if (!d) { d = document.createElement('dialog'); d.id = 'oo-sheet'; d.className = 'oo oo-sheet'; d.setAttribute('aria-labelledby', 'oo-sheet-h'); document.body.appendChild(d); }
    var p = cfg.products[product];
    var yes = '<span class="oo-yes" role="img" aria-label="Included">' + check() + '</span>';
    var no = '<span class="oo-no" role="img" aria-label="Not included"></span>';
    var rows = C.sheetRows.map(function (r) {
      var once = r.once === true || (r.once === 'sock' && product !== 'sight') || (r.once === 'cam' && product !== 'sock');
      var onceCell = r.onceText ? '<span class="oo-compare__txt">' + r.onceText + '</span>' : (once ? yes : no);
      var ooCell = r.ooText ? '<span class="oo-compare__txt is-strong">' + r.ooText + '</span>' : yes;
      return '<tr><th scope="row">' + t(r.label, product) + (r.ship ? '<small class="oo-ship">' + C.thermShip + '</small>' : '') + '</th><td>' + onceCell + '</td><td class="is-oo">' + ooCell + '</td></tr>';
    }).join('');
    var primary = mode === 'cart'
      ? '<button type="button" class="oo-btn oo-btn--primary" data-oo-action="sheet-swap">' + C.swap + '</button>'
      : '<button type="button" class="oo-btn oo-btn--primary" data-oo-action="sheet-choose">' + C.chooseOO + '</button>';

    d.innerHTML =
      '<div class="oo-sheet__in">' +
        '<button type="button" class="oo-sheet__x" data-oo-action="sheet-close" aria-label="' + C.close + '"><svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
        logo() +
        '<h2 id="oo-sheet-h" class="oo-h2">' + t(C.promise, product) + '</h2>' +
        '<table class="oo-compare oo-compare--sheet"><thead><tr><td></td><th scope="col">' + t(C.sheetCompareOnce, product) + '</th><th scope="col" class="is-oo">Owlet One</th></tr></thead><tbody>' + rows +
          '<tr class="oo-compare__sum"><th scope="row">' + C.sheetToday + '</th><td>' + money(p.price) + '</td><td class="is-oo">' + money(cfg.owletOne.upfront) + '</td></tr>' +
          '<tr class="oo-compare__sum"><th scope="row">' + C.sheetThen + '</th><td>' + C.sheetThenOnce + '</td><td class="is-oo">' + t(C.sheetThenOO, product) + '</td></tr>' +
        '</tbody></table>' +
        '<h3 class="oo-h3">' + t(C.sheetCoversTitle, product) + '</h3><p class="oo-p">' + t(C.sheetCovers, product) + '</p>' +
        '<div class="oo-faq">' + C.faq.map(function (f) { return '<details><summary>' + t(f.q, product) + '</summary><p>' + t(f.a, product) + '</p></details>'; }).join('') + '</div>' +
        '<p class="oo-fine">' + t(C.fine, product) + '</p>' +
      '</div>' +
      '<div class="oo-sheet__bar"><button type="button" class="oo-btn oo-btn--secondary" data-oo-action="sheet-keep">' + t(C.keep, product) + '</button>' + primary + '</div>';
    d._product = product; d._mode = mode;
    if (d.showModal) d.showModal(); else d.setAttribute('open', '');
    document.documentElement.classList.add('oo-sheet-open');
  }
  function closeSheet() {
    var d = $('#oo-sheet'); if (!d) return;
    if (d.close) d.close(); else d.removeAttribute('open');
    document.documentElement.classList.remove('oo-sheet-open');
  }

  var planState = 'once';

  function renderPlan(mount) {
    var product = attrProduct(mount) || pageProduct() || 'sock';
    var dir = mount.getAttribute('data-oo-direction') || cell;
    var p = cfg.products[product];
    var name = 'oo-plan-' + Math.random().toString(36).slice(2, 7);
    var html = '';

    if (dir === 'A3') {

      var yes = '<span class="oo-yes" role="img" aria-label="Included">' + check() + '</span>';
      var no = '<span class="oo-no" role="img" aria-label="Not included"></span>';
      var rows = ['sock', 'sight', 'therm', 'stand', 'o360'].map(function (k) {
        var inOnce = k === 'sock' || (k === 'sight' && product === 'duo');
        return '<tr><th scope="row"><span class="oo-cmp__item">' + thumbs([k], 'oo-thumbs--cmp') + '<span>' + t(C.items[k].name, product) + (k === 'therm' ? '<small class="oo-ship">' + C.thermShip + '</small>' : '') + '</span></span></th>' +
          '<td class="c-once">' + (inOnce ? yes : no) + '</td><td class="c-oo">' + yes + '</td></tr>';
      }).join('');
      html =
        '<div class="oo-seg" role="radiogroup" aria-label="' + C.choose + '">' +
          '<span class="oo-seg__thumb" aria-hidden="true"></span>' +
          '<label class="oo-seg__opt"><input type="radio" name="' + name + '" value="once" checked><span>' + t(C.segOnce, product) + '</span></label>' +
          '<label class="oo-seg__opt"><input type="radio" name="' + name + '" value="oo"><span>' + C.segOO + '</span></label>' +
        '</div>' +
        '<div class="oo-cmp">' +
          '<table class="oo-cmp__t">' +
            '<thead><tr><td></td><th scope="col" class="c-once"><span class="oo-cmp__name">' + t(C.onceTitle, product) + '</span></th>' +
              '<th scope="col" class="c-oo"><img class="oo-cmp__logo" src="' + img('ooLogo') + '" alt="Owlet One" width="84" height="22"></th></tr></thead>' +
            '<tbody>' + rows +
              '<tr class="oo-cmp__money"><th scope="row">' + C.sheetToday + '</th><td class="c-once">' + money(p.price) + '</td><td class="c-oo">' + money(cfg.owletOne.upfront) + '</td></tr>' +
              '<tr class="oo-cmp__money"><th scope="row">' + C.sheetThen + '</th><td class="c-once"><span class="oo-cmp__none">-</span></td><td class="c-oo">' + money(cfg.owletOne.monthly) + '<small>/mo</small></td></tr>' +
            '</tbody>' +
          '</table>' +

          '<div class="oo-cmp__more"><div class="oo-cmp__more-in"><div class="oo-cmp__covers">' +
            '<p class="oo-cmp__covers-h">' + t(C.coversShort, product) + '</p>' +
            '<p class="oo-cmp__covers-s">' + t(C.terms, product) + ' <button type="button" class="oo-link" data-oo-action="details">' + C.details + '</button></p>' +
          '</div></div></div>' +
        '</div>';
    } else if (dir === 'A2') {

      var tiles = ['sock', 'sight', 'therm', 'stand', 'o360'].map(function (k, i) {
        var base = k === 'sock' || (k === 'sight' && product === 'duo');
        return '<li class="oo-box__tile' + (base ? ' is-base' : ' is-add') + '" style="--i:' + i + '">' + thumbs([k], 'oo-thumbs--tile') +
          '<span class="oo-box__name">' + t(C.items[k].name, product).replace(' camera', '') + '</span>' + (k === 'therm' ? '<small class="oo-ship">' + C.thermShip + '</small>' : '') +
          '<span class="oo-box__tag">' + (base ? C.boxYours : check() + ' ' + C.boxAdded) + '</span></li>';
      }).join('');
      html =
        '<p class="oo-label" id="' + name + '-l">' + C.choose + '</p>' +
        '<div class="oo-cards" role="radiogroup" aria-labelledby="' + name + '-l">' +
          '<div class="oo-card oo-card--once">' +
            '<label class="oo-card__head">' +
              '<input type="radio" name="' + name + '" value="once" checked>' +
              '<span class="oo-card__radio" aria-hidden="true">' + check() + '</span>' +
              '<span class="oo-card__body"><span class="oo-card__title">' + t(C.onceTitle, product) + ' only</span></span>' +
              '<span class="oo-card__price"><b>' + money(p.price) + '</b><small>' + C.oncePriceNote + '</small></span>' +
            '</label>' +
          '</div>' +
          '<div class="oo-card oo-card--oo">' +
            '<label class="oo-card__head">' +
              '<input type="radio" name="' + name + '" value="oo" aria-describedby="' + name + '-box">' +
              '<span class="oo-card__radio" aria-hidden="true">' + check() + '</span>' +
              '<span class="oo-card__body"><span class="oo-card__title">With Owlet One</span><span class="oo-card__sub">' + t(C.ooSub, product) + '</span></span>' +
              '<span class="oo-card__price"><b>' + money(cfg.owletOne.upfront) + '</b><small>+ ' + money(cfg.owletOne.monthly) + '/mo</small></span>' +
            '</label>' +
            '<div class="oo-card__more" id="' + name + '-box"><div class="oo-card__more-in">' +
              '<p class="oo-box__label">' + C.inTheBox + '</p>' +
              '<ul class="oo-box__grid">' + tiles + '</ul>' +
              '<p class="oo-card__covers">' + t(C.covers, product) + '</p>' +
              '<p class="oo-card__terms">' + t(C.terms, product) + ' <button type="button" class="oo-link" data-oo-action="details">' + C.details + '</button></p>' +
            '</div></div>' +
          '</div>' +
        '</div>';
    } else if (dir === 'A4') {

      var y4 = '<span class="oo-yes" role="img" aria-label="Included">' + check() + '</span>';
      var n4 = '<span class="oo-no" role="img" aria-label="Not included"></span>';
      var rows4 = ['sock', 'sight', 'therm', 'stand', 'o360'].map(function (k) {
        var inOnce = k === 'sock' || (k === 'sight' && product === 'duo');
        return '<tr><th scope="row"><span class="oo-cmp__item">' + thumbs([k], 'oo-thumbs--cmp') + '<span>' + t(C.items[k].name, product) + (k === 'therm' ? '<small class="oo-ship">' + C.thermShip + '</small>' : '') + '</span></span></th>' +
          '<td class="c-once">' + (inOnce ? y4 : n4) + '</td><td class="c-oo">' + y4 + '</td></tr>';
      }).join('');
      html =
        '<p class="oo-label" id="' + name + '-l">' + C.choose + '</p>' +
        '<div class="oo-cards" role="radiogroup" aria-labelledby="' + name + '-l">' +
          '<div class="oo-card oo-card--once">' +
            '<label class="oo-card__head">' +
              '<input type="radio" name="' + name + '" value="once" checked>' +
              '<span class="oo-card__radio" aria-hidden="true">' + check() + '</span>' +
              '<span class="oo-card__body"><span class="oo-card__title">' + t(C.onceTitle, product) + '</span></span>' +
              '<span class="oo-card__price"><b>' + money(p.price) + '</b><small>' + C.oncePriceNote + '</small></span>' +
            '</label>' +
          '</div>' +
          '<div class="oo-card oo-card--oo">' +
            '<label class="oo-card__head">' +
              '<input type="radio" name="' + name + '" value="oo" aria-describedby="' + name + '-cmp">' +
              '<span class="oo-card__radio" aria-hidden="true">' + check() + '</span>' +
              '<span class="oo-card__body"><span class="oo-card__title">' + C.ooTitle + '</span><span class="oo-card__sub">' + t(C.ooSub, product) + '</span></span>' +
              '<span class="oo-card__price"><b>' + money(cfg.owletOne.upfront) + '</b><small>+ ' + money(cfg.owletOne.monthly) + '/mo</small></span>' +
            '</label>' +
            '<div class="oo-card__more" id="' + name + '-cmp"><div class="oo-card__more-in">' +
              '<table class="oo-cmp__t">' +
                '<thead><tr><td></td><th scope="col" class="c-once"><span class="oo-cmp__name">' + t(C.onceTitle, product) + '</span></th>' +
                  '<th scope="col" class="c-oo"><img class="oo-cmp__logo" src="' + img('ooLogo') + '" alt="Owlet One" width="84" height="22"></th></tr></thead>' +
                '<tbody>' + rows4 +
                  '<tr class="oo-cmp__money"><th scope="row">' + C.sheetToday + '</th><td class="c-once">' + money(p.price) + '</td><td class="c-oo">' + money(cfg.owletOne.upfront) + '</td></tr>' +
                  '<tr class="oo-cmp__money"><th scope="row">' + C.sheetThen + '</th><td class="c-once"><span class="oo-cmp__none">-</span></td><td class="c-oo">' + money(cfg.owletOne.monthly) + '<small>/mo</small></td></tr>' +
                '</tbody>' +
              '</table>' +
              '<div class="oo-cmp__covers">' +
                '<p class="oo-cmp__covers-h">' + t(C.coversShort, product) + '</p>' +
                '<p class="oo-cmp__covers-s">' + t(C.terms, product) + '</p>' +
              '</div>' +

              '<button type="button" class="oo-howbtn" data-oo-action="details"><span class="oo-howbtn__i" aria-hidden="true">i</span><span>' + C.details + '</span>' + chevron() + '</button>' +
            '</div></div>' +
          '</div>' +
        '</div>';
    } else {
      var list = ['sock', 'sight', 'therm', 'stand', 'o360'].map(function (k) {
        return '<li>' + thumbs([k], 'oo-thumbs--inc') + '<span class="oo-inc__t"><strong>' + t(C.items[k].name, product) + '</strong><small>' + t(C.items[k].note, product) + '</small>' + (k === 'therm' ? '<small class="oo-ship">' + C.thermShip + '</small>' : '') + '</span><em>' + C.included + '</em></li>';
      }).join('');
      html =
        '<p class="oo-label" id="' + name + '-l">' + C.choose + '</p>' +
        '<div class="oo-cards" role="radiogroup" aria-labelledby="' + name + '-l">' +
          '<div class="oo-card oo-card--once">' +
            '<label class="oo-card__head">' +
              '<input type="radio" name="' + name + '" value="once" checked>' +
              '<span class="oo-card__radio" aria-hidden="true">' + check() + '</span>' +
              '<span class="oo-card__body"><span class="oo-card__title">' + t(C.onceTitle, product) + '</span></span>' +
              '<span class="oo-card__price"><b>' + money(p.price) + '</b><small>' + C.oncePriceNote + '</small></span>' +
            '</label>' +
          '</div>' +
          '<div class="oo-card oo-card--oo">' +
            '<label class="oo-card__head">' +
              '<input type="radio" name="' + name + '" value="oo" aria-describedby="' + name + '-inc">' +
              '<span class="oo-card__radio" aria-hidden="true">' + check() + '</span>' +
              '<span class="oo-card__body"><span class="oo-card__title">' + C.ooTitle + '</span><span class="oo-card__sub">' + t(C.ooSub, product) + '</span></span>' +
              '<span class="oo-card__price"><b>' + money(cfg.owletOne.upfront) + '</b><small>+ ' + money(cfg.owletOne.monthly) + '/mo</small></span>' +
            '</label>' +
            '<div class="oo-card__more" id="' + name + '-inc"><div class="oo-card__more-in">' +
              '<ul class="oo-inc">' + list + '</ul>' +
              '<p class="oo-card__covers">' + t(C.covers, product) + '</p>' +
              '<p class="oo-card__terms">' + t(C.terms, product) + ' <button type="button" class="oo-link" data-oo-action="details">' + C.details + '</button></p>' +
            '</div></div>' +
          '</div>' +
        '</div>';
    }

    mount.className = 'oo oo-plan oo-plan--' + dir.toLowerCase();
    mount.setAttribute('data-oo-state', 'once');
    mount.innerHTML = html;
    mount._product = product;
    mount.addEventListener('change', function (e) { if (e.target.name === name) setPlan(e.target.value, mount); });
    track('impression', { component: 'plan', direction: dir, product: product });
  }

  function setPlan(state, mount) {
    planState = state;
    mount = mount || $('.oo-plan');
    var product = (mount && mount._product) || pageProduct() || 'sock';
    $$('.oo-plan').forEach(function (m) {
      m.setAttribute('data-oo-state', state);
      $$('input[type=radio]', m).forEach(function (r) { r.checked = r.value === state; });
    });
    document.documentElement.classList.toggle('oo-plan-oo', state === 'oo');
    if (state === 'oo') {
      var onlyColor = $(cfg.selectors.variantBlock + ' input[type=radio][value="' + cfg.owletOne.color + '"]');
      if (onlyColor && !onlyColor.checked) onlyColor.click();
    }
    syncTheme(product, state);
    track('select_plan', { plan: state, product: product });
  }

  var themeReady = false, atcOriginal = null, priceSwap = null, mediaLayer = null, affirmEl = null, affirmText = null;
  function prepTheme(product) {
    if (themeReady) return; themeReady = true;
    var S = cfg.selectors;

    $$('xo-animate, div', $(S.productInfo) || document).forEach(function (el) {
      if (el.children.length < 6 && (el.innerText || el.textContent).trim().indexOf(S.affirmText) === 0) {
        el.classList.add('oo-hide-when-oo');
        if (!affirmEl) affirmEl = el;
      }
    });
    $$(S.buyNow + ',' + S.addOns).forEach(function (el) { el.classList.add('oo-hide-when-oo'); });

    var price = $(S.price);
    if (price) {
      priceSwap = document.createElement('div');
      priceSwap.className = 'oo oo-price-swap';

      var priceText = $('.xo-price__item', price) || price, pcs = getComputedStyle(priceText);
      var themeAmount = priceText.textContent.replace(/\s+/g, ' ').trim();
      var ooAmount = /\d/.test(themeAmount)
        ? themeAmount.replace(/\d[\d,]*(\.\d+)?/, String(Math.round(cfg.owletOne.upfront * 100) % 100 ? cfg.owletOne.upfront.toFixed(2) : Math.round(cfg.owletOne.upfront))).replace(/\s*[A-Z]{3}$/, '')
        : money(cfg.owletOne.upfront);
      priceSwap.innerHTML =
        '<div class="oo-price-swap__line"><span class="oo-price-swap__big">' + esc(ooAmount) + '</span> <span class="oo-price-swap__unit">' + C.priceToday + '</span> <span class="oo-price-swap__mo">+ ' + money(cfg.owletOne.monthly) + '/mo</span></div>' +
        '<p class="oo-price-swap__note">' + t(C.priceNote, product) + '</p>';
      var big = $('.oo-price-swap__big', priceSwap), line = $('.oo-price-swap__line', priceSwap);
      ['fontFamily', 'fontSize', 'fontWeight', 'letterSpacing', 'color', 'lineHeight'].forEach(function (k) { big.style[k] = pcs[k]; });
      line.style.lineHeight = pcs.lineHeight;
      if (affirmEl) {

        var walker = document.createTreeWalker(affirmEl, NodeFilter.SHOW_TEXT), node, src = affirmEl;
        while ((node = walker.nextNode())) { if (node.nodeValue.indexOf(S.affirmText.slice(0, 7)) > -1) { src = node.parentElement; affirmText = node; break; } }
        var cs = getComputedStyle(src), note = $('.oo-price-swap__note', priceSwap);
        ['fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'letterSpacing', 'color'].forEach(function (k) { note.style[k] = cs[k]; });
      }
      price.classList.add('oo-hide-when-oo');
      price.parentNode.insertBefore(priceSwap, price.nextSibling);
    }

    var stage = $(S.mediaStage);
    if (stage) {
      mediaLayer = document.createElement('div');
      mediaLayer.className = 'oo oo-media';
      mediaLayer.setAttribute('aria-hidden', 'true');

      var pills = [['Owlet360™', 'o360'], ['Infant CPR course', 'cpr'], ['Gift drops', 'gifts'], ['Member perks', 'perks']];
      mediaLayer.innerHTML =
        '<div class="oo-media__glow"></div>' +
        '<img class="oo-media__logo" src="' + img('ooLogo') + '" alt="">' +
        '<img class="oo-media__o oo-media__sight" src="' + img('sightCut') + '" alt="">' +
        '<img class="oo-media__o oo-media__therm" src="' + img('thermCut') + '" alt="">' +
        '<img class="oo-media__o oo-media__base" src="' + img('baseCut') + '" alt="">' +
        '<img class="oo-media__o oo-media__sock" src="' + sockSrc(product) + '" alt="" data-oo-sock>' +
        '<img class="oo-media__o oo-media__app" src="' + img('appCut') + '" alt="">' +
        '<div class="oo-media__o oo-mr"><div class="oo-mr__head"><img src="' + img('mrSun') + '" alt=""><span>Morning Report</span><img src="' + img('mrChevron') + '" alt=""></div>' +
          '<div class="oo-mr__meter"><img src="' + img('mrArc') + '" alt=""><span>Restful</span></div><span class="oo-mr__chip">Total Night Sleep: 7h 26m</span></div>' +
        pills.map(function (pl, i) { return '<span class="oo-pill oo-media__p oo-media__p--' + pl[1] + '" style="--d:' + (i * 70) + 'ms">' + pl[0] + '</span>'; }).join('');
      if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
      stage.appendChild(mediaLayer);
    }

    function intercept(e) {
      if (planState !== 'oo') return;
      var atc = e.target.closest && e.target.closest(S.addToCart);
      var form = e.type === 'submit' && e.target.closest && e.target.closest(S.buyForm);
      if (!atc && !form) return;
      e.preventDefault(); e.stopImmediatePropagation();
      withBusy(atc || null, function () { return addOwletOne({ product: product, source: cell }); });
    }
    document.addEventListener('click', intercept, true);
    document.addEventListener('submit', intercept, true);
  }

  function atcLabel() {
    var btn = $(cfg.selectors.addToCart);
    return btn && ($('.xo-btn__text', btn) || btn);
  }
  function keepAtcLabel() {
    if (keepAtcLabel._on || !window.MutationObserver) return;
    keepAtcLabel._on = true;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        tagOnceForms();
        var label = atcLabel();
        if (planState === 'oo' && label && label.textContent.trim() !== C.atcOO) label.textContent = C.atcOO;
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function tagOnceForms() {
    if (family !== 'A' || cell === 'control' || !pageProduct()) return;
    $$('form[action*="/cart/add"]', $(cfg.selectors.productInfo) || document).forEach(function (f) {
      if (f.querySelector('input[name="properties[_oo_page]"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = 'properties[_oo_page]'; i.value = location.pathname;
      f.appendChild(i);
    });
  }

  function syncTheme(product, state) {
    prepTheme(product);
    var label = atcLabel();
    if (label) {
      if (atcOriginal === null) atcOriginal = label.textContent.trim();
      label.textContent = state === 'oo' ? C.atcOO : atcOriginal;
    }
    keepAtcLabel();
    if (mediaLayer) mediaLayer.classList.toggle('is-on', state === 'oo');
    if (state === 'oo') renderMore(product);
    if (state === 'oo') fitPriceSwap();
  }

  function textTop(nodeOrEl) {
    var r = document.createRange(); r.selectNodeContents(nodeOrEl);
    var rects = Array.prototype.filter.call(r.getClientRects(), function (q) { return q.width > 0; });
    return rects.length ? rects[0].top : null;
  }
  function fitPriceSwap() {
    var price = $(cfg.selectors.price), next = $(cfg.selectors.variantBlock);
    if (!priceSwap || !price || !next) return;
    next = next.closest('xo-animate') || next;
    var line = $('.oo-price-swap__line', priceSwap), note = $('.oo-price-swap__note', priceSwap);
    var root = document.documentElement, on = root.classList.contains('oo-plan-oo');

    root.classList.remove('oo-plan-oo');
    var pr = price.getBoundingClientRect(), af = affirmEl && affirmEl.getBoundingClientRect();
    var subTarget = affirmText ? textTop(affirmText) : null;
    var target = next.getBoundingClientRect().top - pr.top;

    root.classList.add('oo-plan-oo');
    line.style.height = pr.height.toFixed(2) + 'px';
    var gap = af && af.height ? Math.max(0, af.top - pr.bottom) : 8;
    note.style.marginTop = gap.toFixed(2) + 'px';
    if (subTarget !== null) {
      var d = subTarget - textTop(note);
      note.style.marginTop = Math.max(0, gap + d).toFixed(2) + 'px';
    }
    priceSwap.style.paddingBottom = '0px';
    var actual = next.getBoundingClientRect().top - priceSwap.getBoundingClientRect().top;
    priceSwap.style.paddingBottom = Math.max(0, target - actual).toFixed(2) + 'px';
    if (!on) root.classList.remove('oo-plan-oo');
  }
  var fitTimer;
  window.addEventListener('resize', function () {
    if (planState !== 'oo') return;
    clearTimeout(fitTimer); fitTimer = setTimeout(fitPriceSwap, 120);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (planState === 'oo') fitPriceSwap(); });

  var moreEl = null;
  function renderMore(product) {
    if (moreEl) return;
    var anchor = $(cfg.selectors.ooContentAfter);
    if (!anchor) return;
    var p = cfg.products[product], oo = cfg.owletOne;
    var inc = '<span class="jc-inc">Included</span>';
    var no = '<span class="jc-no" aria-hidden="true">–</span><span class="oo-vh">Not included</span>';
    function chip(v) { return '<span class="jc-val"><span class="jc-inc">Included</span><span class="jc-chip">' + v + '</span></span>'; }
    function zero(v) { return '<span class="jc-val"><s class="jc-was">' + v + '</s><span class="jc-inc jc-zero">$0</span></span>'; }
    var chev = '<span class="oo-xfaq__toggle" aria-hidden="true"><span class="oo-xfaq__bar"></span><span class="oo-xfaq__bar oo-xfaq__bar--v"></span></span>';
    var faqs = [C.faqWhy].concat(C.faq);
    moreEl = document.createElement('div');
    moreEl.className = 'oo oo-more-pdp';
    moreEl.setAttribute('aria-label', 'About Owlet One');
    moreEl.innerHTML =
      '<section class="oo-xsec"><div class="oo-xwrap">' +
        '<h2 class="oo-xh2">' + t(C.moreH, product) + '</h2>' +
        '<div class="oo-xcards">' +
          '<article class="oo-xcard"><div class="oo-xcard__media"><img src="' + img('cardSock') + '" alt="Dream Sock on a baby\'s foot, with live pulse rate and oxygen level readings" loading="lazy"></div><div class="oo-xcard__body"><h3 class="oo-xh3">Dream Sock®</h3><p>' + t(C.moreSock, product) + '</p></div></article>' +
          '<article class="oo-xcard"><div class="oo-xcard__media"><img src="' + img('cardSight') + '" alt="A phone showing a sleeping baby on the Dream Sight™ Camera feed" loading="lazy"></div><div class="oo-xcard__body"><h3 class="oo-xh3">Dream Sight™ Camera</h3><p>' + t(C.moreSight, product) + '</p></div></article>' +
          '<article class="oo-xcard"><div class="oo-xcard__media"><img src="' + img('cardTherm') + '" alt="A parent taking a child\'s temperature with the Smart Thermometer, with readings synced to the app" loading="lazy"></div><div class="oo-xcard__body"><h3 class="oo-xh3">Smart Thermometer</h3><p>' + C.moreTherm + '</p><small class="oo-ship">' + C.thermShip + '</small></div></article>' +
        '</div>' +
        '<div class="oo-x360"><div class="oo-x360__text"><h3 class="oo-xh3">What your <em>' + money(oo.monthly) + '/mo</em> pays for</h3><p>' + t(C.pays, product) + '</p><ul>' +
          C.paysList.map(function (li) { return '<li>' + check() + '<span>' + li + '</span></li>'; }).join('') + '</ul></div>' +
          '<div class="oo-x360__vis"><img class="oo-x360__phone" src="' + img('appCut') + '" alt="" loading="lazy">' +
            '<div class="oo-mr oo-x360__mr"><div class="oo-mr__head"><img src="' + img('mrSun') + '" alt=""><span>Morning Report</span><img src="' + img('mrChevron') + '" alt=""></div><div class="oo-mr__meter"><img src="' + img('mrArc') + '" alt=""><span>Restful</span></div><span class="oo-mr__chip">Total Night Sleep: 7h 26m</span></div>' +
          '</div></div>' +
      '</div></section>' +
      '<section class="oo-xsec"><div class="oo-xwrap oo-xwrap--narrow">' +
        '<h2 class="oo-xh2">' + C.chartH + '</h2>' +
        '<div class="oo-xjc-card"><table class="oo-xjc"><caption class="oo-vh">What’s included with Owlet One and with ' + p.short + ' only</caption>' +
          '<thead><tr><th scope="col" class="jc-feat"><span class="jc-label">What you get</span></th><th scope="col" class="jc-hl"><span class="jc-label">Owlet One</span></th><th scope="col"><span class="jc-label">' + p.short + ' only</span></th></tr></thead><tbody>' +
          '<tr><th scope="row">Dream Sock®</th><td class="jc-hl">' + chip(money(cfg.products.sock.price)) + '</td><td>' + inc + '</td></tr>' +
          '<tr><th scope="row">Dream Sight™ Camera</th><td class="jc-hl">' + (product === 'duo' ? inc : zero('$99')) + '</td><td>' + (product === 'duo' ? inc : no) + '</td></tr>' +
          '<tr><th scope="row">Smart Thermometer<small class="oo-ship">' + C.thermShip + '</small></th><td class="jc-hl">' + zero('$49') + '</td><td>' + no + '</td></tr>' +
          '<tr><th scope="row">Dream Sight™ Floor Stand</th><td class="jc-hl">' + zero('$89') + '</td><td>' + no + '</td></tr>' +
          '<tr><th scope="row">Owlet360™ insights</th><td class="jc-hl">' + zero('$99/yr') + '</td><td>' + no + '</td></tr>' +
          '<tr><th scope="row">Warranty</th><td class="jc-hl"><span class="jc-inc">18 months</span></td><td><span class="jc-txt">12 months</span></td></tr>' +
          '<tr><th scope="row">Member perks</th><td class="jc-hl">' + inc + '</td><td>' + no + '</td></tr>' +
          '<tr class="jc-sum"><th scope="row">What you pay</th><td class="jc-hl"><span class="jc-inc jc-pay">' + money(oo.upfront) + '</span><span class="jc-inc jc-plus">+ ' + money(oo.monthly) + '/month</span><span class="jc-note">' + oo.commitmentMonths + '-month minimum</span></td><td><span class="jc-txt jc-pay">' + money(p.price) + '</span><span class="jc-note">one time</span></td></tr>' +
        '</tbody></table></div>' +
      '</div></section>' +
      '</div></section>';
    anchor.parentNode.insertBefore(moreEl, anchor.nextSibling);

    var item = function (q, aHTML) { return '<div class="oo-xfaq__item"><button type="button" class="oo-xfaq__q" aria-expanded="false" data-oo-action="xfaq"><span>' + q + '</span>' + chev + '</button><div class="oo-xfaq__a"><div class="oo-xfaq__body">' + aHTML + '</div></div></div>'; };
    var rows = faqs.map(function (f) { return item(t(f.q, product), '<p>' + t(f.a, product) + '</p>'); });
    var pf = $(cfg.selectors.productFaq);
    if (pf) {
      $$(cfg.selectors.productFaqItem, pf).forEach(function (it) {
        var q = $(cfg.selectors.productFaqQ, it), a = $(cfg.selectors.productFaqA, it);
        if (q && a && q.textContent.trim()) rows.push(item(esc(q.textContent.trim()), a.innerHTML));
      });
      pf.classList.add('oo-hide-when-oo');
    }
    var faqEl = document.createElement('div');
    faqEl.className = 'oo oo-more-pdp oo-more-faq';
    faqEl.innerHTML = '<section class="oo-xsec"><div class="oo-xwrap oo-xwrap--narrow">' +
        '<h2 class="oo-xh2">' + C.faqH + '</h2><div class="oo-xfaq">' + rows.join('') + '</div>' +
        '<p class="oo-fine oo-xfine">' + t(C.fine, product) + '</p>' +
      '</div></section>';
    if (pf) pf.parentNode.insertBefore(faqEl, pf.nextSibling); else moreEl.appendChild(faqEl.firstChild);
  }

  function renderCross(mount) {
    var product = attrProduct(mount) || pageProduct() || 'sock';
    var dir = mount.getAttribute('data-oo-direction') || cell;
    var url = cfg.landingUrl + (cfg.landingUrl.indexOf('?') > -1 ? '&' : '?') + 'from=' + product + '&color=' + encodeURIComponent(selectedColor(product)) + '&oo_src=' + encodeURIComponent(dir);
    mount.className = 'oo oo-cross oo-cross--' + dir.toLowerCase().replace('b-', '');
    if (dir === 'B-row') {
      mount.innerHTML = '<a class="oo-cross__row" href="' + url + '" data-oo-action="cross-click">' + thumbs(addKeys(product), 'oo-thumbs--stack') + '<span>' + t(C.crossRow, product) + ' <u>' + C.crossLink + '</u></span>' + chevron() + '</a>';
    } else {
      mount.innerHTML =
        '<div class="oo-cross__card">' +
          '<div class="oo-cross__art" aria-hidden="true"><img class="a1" src="' + img('sightCut') + '" alt=""><img class="a2" src="' + img('thermCut') + '" alt=""><img class="a3" src="' + img('appCut') + '" alt=""></div>' +
          '<div class="oo-cross__txt">' + logo() + '<p class="oo-cross__h">' + t(C.crossTitle, product) + '</p><p class="oo-cross__p">' + t(C.crossText, product) + '</p>' +
          '<a class="oo-link oo-link--arrow" href="' + url + '" data-oo-action="cross-click">' + C.crossLink + chevron() + '</a></div>' +
        '</div>';
    }

    mount._refreshUrl = function () { $$('a', mount).forEach(function (a) { a.href = a.href.replace(/color=[^&]*/, 'color=' + encodeURIComponent(selectedColor(product))); }); };
    track('impression', { component: 'crosssell', direction: dir, product: product });
  }

  var lastCart = null;

  function qualifying(cart) {
    if (!cart) return [];
    var hasOO = cart.items.some(function (i) { return Number(i.variant_id) === cfg.owletOne.variantId; });
    if (hasOO) return [];
    return cart.items.filter(function (i) { return !!productByVariant(i.variant_id); });
  }

  function cartModuleHTML(dir, line, product) {
    var kept = store('oo_kept');
    var head = t(C.cartHead, product);

    var lineColor = (productByVariant(line && line.variant_id) || {}).color;
    var sockThumb = '<span class="oo-thumbs oo-thumbs--c1" aria-hidden="true"><span class="oo-thumbs__i oo-thumbs__i--sock"><img src="' + img(cfg.sockCuts[lineColor && lineColor.name] || cfg.sockCuts.Mint) + '" alt="" loading="lazy"></span></span>';
    var row = function (k, r) { return '<li>' + (k === 'sock' ? sockThumb : thumbs([k], 'oo-thumbs--c1')) + '<span><strong>' + t(r.title, product) + '</strong><small>' + t(r.text, product) + '</small>' + (k === 'therm' ? '<small class="oo-ship">' + C.thermShip + '</small>' : '') + '</span></li>'; };
    var withStand = product === 'sight' && cfg.products.sight.standVariantId === Number(line.variant_id);
    var reasonRows = product === 'sight'
      ? row('sock', C.reasons.sock) + row('therm', C.reasons.therm) + (withStand ? '' : row('stand', C.reasons.stand)) + row('o360', C.reasons.o360) + row('sight', C.reasons.price.sight)
      : product === 'duo'
      ? row('therm', C.reasons.therm) + row('stand', C.reasons.stand) + row('o360', C.reasons.o360) + row('sock', C.reasons.price[product])
      : row('sight', C.reasons.sight) + row('therm', C.reasons.therm) + row('stand', C.reasons.stand) + row('sock', C.reasons.price[product]);
    var sw = colorSwitch(line), colorNote = '';
    if (sw) colorNote = '<div class="oo-colornote"><p>' + fill(C.colorChange, sw, product) + '</p>' + (fabricItem(sw) ? '<label class="oo-addon"><input type="checkbox" data-oo-addon><span>' + fill(C.addonLabel, sw, product) + '</span></label>' : '') + '</div>';
    var body =
      '<div class="oo-swap__head">' + logo() + '<p class="oo-swap__h">' + head + '</p></div>' +
      '<ul class="oo-list oo-list--reasons">' + reasonRows + '</ul>' +
      colorNote +
      '<p class="oo-meta">' + t(C.covers, product) + ' <button type="button" class="oo-link" data-oo-action="details-cart">' + C.details + '</button></p>' +
      '<div class="oo-swap__ctas"><button type="button" class="oo-btn oo-btn--secondary oo-btn--sm" data-oo-action="keep">' + t(C.keep, product) + '</button><button type="button" class="oo-btn oo-btn--primary oo-btn--sm" data-oo-action="swap">' + C.swap + '</button></div>' +
      '<p class="oo-fine oo-fine--xs">' + t(C.terms, product) + '</p>';

    if (dir === 'C2') {

      var pName = cfg.products[product].name;
      return '<div class="oo-line-toggle" role="radiogroup" aria-label="How would you like to pay?">' +
          '<label class="oo-line-toggle__o is-on"><input type="radio" name="oo-lt-' + line.key + '" value="once" checked>' +
            '<span class="oo-line-toggle__top"><span class="oo-card__radio oo-line-toggle__check" aria-hidden="true">' + check() + '</span><b>' + C.lineOnce + '</b></span>' +
            '<span class="oo-line-toggle__price">' + money(cfg.products[product].price) + ' <small>one time</small></span>' +
            '<span class="oo-line-toggle__detail">' + pName + ' only</span></label>' +
          '<label class="oo-line-toggle__o"><input type="radio" name="oo-lt-' + line.key + '" value="oo" data-oo-action="swap">' +
            '<span class="oo-line-toggle__top"><span class="oo-card__radio oo-line-toggle__check" aria-hidden="true">' + check() + '</span><b>' + C.lineOO + '</b></span>' +
            '<span class="oo-line-toggle__price">' + money(cfg.owletOne.upfront) + ' <small>+ ' + money(cfg.owletOne.monthly) + '/mo</small></span>' +
            '<span class="oo-line-toggle__detail">' + (product === 'duo' ? C.lineOOCaptionDuo : C.lineOOCaption) + '</span></label>' +
        '</div>' +
        '<p class="oo-line-toggle__cap"><button type="button" class="oo-link" data-oo-action="details-cart">' + C.details + '</button></p>';
    }
    if (kept) {
      var openNow = store('oo_nudge_open');
      return '<button type="button" class="oo-nudge" data-oo-action="nudge" aria-expanded="' + (openNow ? 'true' : 'false') + '"><span>' + (kept ? (product === 'duo' ? C.keptRowDuo : product === 'sight' ? t(C.keptRowSight, product) : t(C.keptRow, product)) : t(C.nudge, product)) + '</span><u>' + (kept ? C.show : C.nudgeCta) + '</u></button>' +
        '<div class="oo-swap oo-swap--inline"' + (openNow ? '' : ' hidden') + '>' + body + '</div>';
    }
    return '<div class="oo-swap">' + body + '</div>';
  }

  function swappedNote(product, swap) {
    if (!swap || !swap.color || swap.color === cfg.owletOne.color || swap.product === 'sight') return '';
    return '<p class="oo-swapped__p oo-swapped__color">' + fill(C.changedToMint, swap.color, product) + '</p>' +
      (!swap.addon && fabricItem(swap.color) ? '<button type="button" class="oo-link" data-oo-action="addon">' + fill(C.addonAdd, swap.color, product) + '</button>' : '');
  }

  function swappedHTML(product, swap) {
    return '<div class="oo-swapped"><span class="oo-swapped__ico">' + check() + '</span><div><p class="oo-swapped__h">' + C.swapped + '</p><p class="oo-swapped__p">' + (product === 'duo' ? C.swappedTextDuo : product === 'sight' ? C.swappedTextSight : C.swappedText) + '</p>' + swappedNote(product, swap) + '<button type="button" class="oo-link" data-oo-action="undo">' + t(C.undo, product) + '</button></div></div>';
  }

  function renderCart(cart) {
    if (!cartCell) return;
    lastCart = cart || lastCart;
    var drawer = $(cfg.selectors.cartDrawer); if (!drawer || !lastCart) return;
    $$('.oo-cart-mod', drawer).forEach(function (n) { n.remove(); });
    var swap = store('oo_swap');
    var ooLine = lastCart.items.filter(function (i) { return Number(i.variant_id) === cfg.owletOne.variantId; })[0];

    if (swap && ooLine) {
      var lineEl = $(cfg.selectors.cartLine + '[' + cfg.selectors.cartLineVariantAttr + '="' + cfg.owletOne.variantId + '"]', drawer);
      if (lineEl) insertAfterLine(lineEl, swappedHTML(swap.product, swap), 'oo-cart-mod oo-cart-mod--swapped');
      return;
    }
    if (swap && !ooLine) store('oo_swap', null);

    if (ooLine) {
      var ooEl = $(cfg.selectors.cartLine + '[' + cfg.selectors.cartLineVariantAttr + '="' + cfg.owletOne.variantId + '"]', drawer);
      if (ooEl) insertAfterLine(ooEl, '<p class="oo-includes">' + C.includesLine + '</p>', 'oo-cart-mod oo-cart-mod--includes', true);
      return;
    }

    var lines = qualifying(lastCart);
    if (!lines.length) return;
    var line = lines[0];
    var product = productByVariant(line.variant_id).product;
    if (product === 'sight') cfg.products.sight.price = line.final_price / 100;
    var el = $(cfg.selectors.cartLine + '[' + cfg.selectors.cartLineVariantAttr + '="' + line.variant_id + '"]', drawer);
    var wrap;
    if (cartCell === 'C1' && !store('oo_kept')) {
      wrap = document.createElement('div');
      wrap.className = 'oo oo-cart-mod oo-cart-mod--c1';
      wrap.innerHTML = cartModuleHTML('C1', line, product);

      var allLines = $$(cfg.selectors.cartLine, drawer), last = allLines[allLines.length - 1];
      var anchor = $(cfg.selectors.cartFooter, drawer);
      if (last) last.parentNode.insertBefore(wrap, last.nextSibling); else if (anchor) anchor.parentNode.insertBefore(wrap, anchor); else drawer.appendChild(wrap);
    } else if (el) {

      wrap = insertAfterLine(el, cartModuleHTML(cartCell, line, product), 'oo-cart-mod oo-cart-mod--' + cartCell.toLowerCase(), false);
    }
    if (wrap) { wrap._line = line; wrap._product = product; }
    if (!renderCart._seen) { renderCart._seen = true; track('impression', { component: 'cart', direction: cartCell, product: product }); }
  }

  function insertAfterLine(lineEl, html, cls, inline) {
    var wrap = document.createElement('div');
    wrap.className = 'oo ' + cls;
    wrap.innerHTML = html;
    var host = inline ? ($(cfg.selectors.cartLineContent, lineEl) || lineEl) : lineEl;
    if (host === lineEl) lineEl.parentNode.insertBefore(wrap, lineEl.nextSibling); else host.appendChild(wrap);
    return wrap;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-oo-action]');
    if (!a) return;
    var act = a.getAttribute('data-oo-action');
    var mod = a.closest('.oo-cart-mod');
    switch (act) {
      case 'color': e.preventDefault(); setColor(a.getAttribute('data-oo-color-name')); break;
      case 'add-owlet-one': e.preventDefault(); withBusy(a, function () { return addOwletOne({ product: attrProduct(a) || ctx.from || undefined, source: attrSource(a) || 'landing' }); }); break;
      case 'add-once': e.preventDefault(); withBusy(a, function () { return addOnce({ product: attrProduct(a) || ctx.from || undefined, source: attrSource(a) || 'landing' }); }); break;
      case 'details': e.preventDefault(); openSheet(pageProduct(), 'pdp'); break;
      case 'details-cart': e.preventDefault(); openSheet(mod && mod._product, 'cart'); break;
      case 'sheet-close': closeSheet(); break;
      case 'sheet-choose': closeSheet(); setPlan('oo'); break;
      case 'sheet-keep':
        closeSheet();
        if ($('#oo-sheet')._mode === 'cart') keepCart(); else setPlan('once');
        break;
      case 'sheet-swap': closeSheet(); var l = qualifying(lastCart)[0]; if (l) withBusy(null, function () { return swapLine(l); }); break;
      case 'swap':
        if (a.tagName === 'INPUT') {  break; }
        e.preventDefault(); if (mod && mod._line) withBusy(a, function () { var cb = mod.querySelector('[data-oo-addon]'); return swapLine(mod._line, { addon: !!(cb && cb.checked) }); }); break;
      case 'addon':
        e.preventDefault();
        withBusy(a, function () {
          var sw = store('oo_swap'), item = sw && fabricItem(sw.color); if (!item) return Promise.resolve();
          track('add_fabric_sock', { color: sw.color });
          store('oo_reopen', Date.now());
          sw.addon = true; store('oo_swap', sw);
          return Cart.add([item]).then(function () { return Cart.refresh(true); }, function (err) { sw.addon = false; store('oo_swap', sw); throw err; });
        }); break;
      case 'keep': e.preventDefault(); keepCart(); break;
      case 'undo': e.preventDefault(); withBusy(a, undoSwap); break;
      case 'nudge':
        e.preventDefault();
        var panel = a.nextElementSibling, open = a.getAttribute('aria-expanded') !== 'true';
        a.setAttribute('aria-expanded', String(open)); if (panel) panel.hidden = !open;
        store('oo_nudge_open', open || null);
        if (open && store('oo_kept')) store('oo_kept', null);
        track(open ? 'nudge_open' : 'nudge_close', {}); break;
      case 'xfaq':
        e.preventDefault();
        var it = a.parentNode, ans = it.querySelector('.oo-xfaq__a'), op = !it.classList.contains('is-open');
        it.classList.toggle('is-open', op); a.setAttribute('aria-expanded', String(op)); ans.style.maxHeight = op ? ans.scrollHeight + 'px' : '0px';
        break;
      case 'cross-click': track('crosssell_click', { direction: cell, product: pageProduct() }); break;
    }
  });

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (r.matches && r.matches('.oo-line-toggle input[value="oo"]') && r.checked) {
      var mod = r.closest('.oo-cart-mod');
      $$('.oo-line-toggle__o', mod).forEach(function (o) { o.classList.toggle('is-on', o.contains(r)); });
      if (mod && mod._line) withBusy(null, function () { return swapLine(mod._line); });
    }
    if (r.closest && r.closest(cfg.selectors.variantBlock)) setTimeout(function () { $$('.oo-cross').forEach(function (m) { m._refreshUrl && m._refreshUrl(); }); syncSockColor(); }, 60);
  });

  function keepCart() {
    store('oo_kept', true); store('oo_nudge_open', null);
    track('keep', { product: (qualifying(lastCart)[0] && productByVariant(qualifying(lastCart)[0].variant_id).product) || null });
    renderCart();
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  document.addEventListener('click', function (e) { var d = $('#oo-sheet'); if (d && e.target === d) closeSheet(); });

  function placeMounts() {
    var product = pageProduct();
    if (!product || family === 'C' || cell === 'control') return;
    tagOnceForms(); keepAtcLabel();
    var S = cfg.selectors;
    if (family === 'A' && !$('[data-oo-plan]')) {
      var anchor = $(S.variantBlock);
      if (anchor) {
        anchor = anchor.closest('xo-animate') || anchor;
        var m = document.createElement('div'); m.setAttribute('data-oo-plan', ''); m.setAttribute('data-oo-product', product);
        anchor.parentNode.insertBefore(m, anchor.nextSibling);
      }
    }
    if (family === 'B' && !$('[data-oo-crosssell]')) {
      var form = $(S.buyForm);
      if (form) {
        var c = document.createElement('div'); c.setAttribute('data-oo-crosssell', ''); c.setAttribute('data-oo-product', product);
        form.parentNode.insertBefore(c, form);
      }
    }
  }

  function mountAll() {
    $$('[data-oo-plan]:not([data-oo-ready])').forEach(function (m) {
      if (family !== 'A' && !m.hasAttribute('data-oo-direction')) return;
      m.setAttribute('data-oo-ready', ''); renderPlan(m);
    });
    $$('[data-oo-crosssell]:not([data-oo-ready])').forEach(function (m) {
      if (family !== 'B' && !m.hasAttribute('data-oo-direction')) return;
      m.setAttribute('data-oo-ready', ''); renderCross(m);
    });
  }

  function landingContext() {
    var from = ctx.from || 'sock';
    var root = document.documentElement;
    root.classList.add('oo-from-' + from);
    $$('[data-oo-show]').forEach(function (el) { el.hidden = el.getAttribute('data-oo-show') !== from; });
    if (ctx.color) $$('[data-oo-color]').forEach(function (el) { el.textContent = colorObj(from, ctx.color).name; });
    renderSwatches(from);
    syncSockColor();
  }

  function renderSwatches(from) {
    var list = (cfg.products[from] || cfg.products.sock).colors;
    var cur = colorObj(from, ctx.color || list[0].name).name;
    $$('[data-oo-swatches]').forEach(function (box, n) {
      box.innerHTML = '<span class="oo-sw__label">Sock color: <b data-oo-color>' + esc(cur) + '</b></span><span class="oo-sw__row" role="radiogroup" aria-label="Sock color">' +
        list.map(function (c) {
          var on = c.name === cur;
          return '<button type="button" class="oo-sw__b' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" aria-label="' + esc(c.name) + '" data-oo-action="color" data-oo-color-name="' + esc(c.name) + '" style="--sw:' + (c.hex || cfg.swatchHex[c.name] || '#ccc') + '"></button>';
        }).join('') + '</span>';
    });
  }
  function setColor(name) {
    var from = ctx.from || 'sock';
    ctx.color = colorObj(from, name).name;
    $$('[data-oo-color]').forEach(function (el) { el.textContent = ctx.color; });
    $$('.oo-sw__b').forEach(function (b) { var on = b.getAttribute('data-oo-color-name') === ctx.color; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on)); });
    syncSockColor();
    try { var u = new URL(location.href); u.searchParams.set('color', ctx.color); history.replaceState(history.state, '', u); } catch (e) {}
    track('color_change', { color: ctx.color, product: from });
  }

  var observing = false;
  function watchCart() {
    if (observing) return;
    observing = true;
    Cart.get().then(renderCart);
    window.addEventListener('oo:cart', function (e) { renderCart(e.detail); });

    var drawer = $(cfg.selectors.cartDrawer);
    if (drawer && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (!cartCell || $('.oo-cart-mod', drawer)) return;
        renderCart();
        if (pending) return; pending = true;
        Cart.get().then(function (cart) { pending = false; renderCart(cart); });
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  function init() {
    document.documentElement.setAttribute('data-oo-cell', cell);
    landingContext();
    placeMounts();
    mountAll();
    if (cartCell) watchCart();
    var reopenAt = store('oo_reopen');
    if (reopenAt) {
      store('oo_reopen', null);
      if (Date.now() - reopenAt < 15000) setTimeout(function () { Cart.open(); }, 800);
    }
  }

  function setCell(next) {
    if (!next || next === cell) return;
    cell = next; family = next.charAt(0);
    if (family === 'C') cartCell = next;
    store('oo_cell', next);
    document.documentElement.setAttribute('data-oo-cell', next);
    $$('[data-oo-plan][data-oo-ready]:not([data-oo-direction]), [data-oo-crosssell][data-oo-ready]:not([data-oo-direction])').forEach(function (m) { m.remove(); });
    placeMounts(); mountAll();
    if (cartCell) watchCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  window.OOCVR = {
    version: '0.1.0', config: cfg, cell: cell, cart: Cart, store: store,
    addOwletOne: addOwletOne, addOnce: addOnce, swapLine: swapLine, undoSwap: undoSwap,
    setPlan: setPlan, setCell: setCell, syncSockColor: syncSockColor, setColor: setColor, openDetails: openSheet, track: track, context: function () { return ctx; },
    remount: function () { placeMounts(); mountAll(); if (cartCell) Cart.get().then(renderCart); }
  };
})();
